import React, { useState } from "react";
import { RiArrowRightSLine } from "react-icons/ri";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { trackOrderApi } from "../utils/api";
import { ClipLoader } from "react-spinners";
// import { useJitsu } from "@jitsu/react";

function OrderBox({
  order,
  settings,
  setOrderDetailsActive,
  setOrderDetails,
  setOrdersLoader,
}) {
  // const { track } = useJitsu();
  const trackOrder = () => {
    // track("clicked_on_order");
    setOrdersLoader(true);
    trackOrderApi(order.order_id, settings.merchant.id).then((resp) => {
      setOrdersLoader(false);
      if (!resp.data.data.show_not_found_error) {
        setOrderDetailsActive(true);
        setOrderDetails(resp.data.data.order);
      }
    });
  };

  const [openRmsIframe, setOpenRmsIframe] = useState(false);
  const [returnLoader, setReturnLoader] = useState(false);

  window.addEventListener("message", (event) => {
    if (event.data.topic === "RMS") {
      if (event.data.message === "close_rms") {
        setOpenRmsIframe(false);
        document.querySelector("body").classList.remove("overflow-hidden");
      }
    }
  });

  const showReturnButton = order.order_items.every(
    (item) => item.exchange_eligible || item.refund_eligible
  );

  return (
    <div className="py-2.5 px-5 my-5 bg-white rounded-xl">
      <div className="cursor-pointer" onClick={() => trackOrder()}>
        {/* Order Number  */}
        <div className="flex items-center">
          <p className="text-xs font-medium">
            Order No. {order.order_number}{" "}
            <span className="text-[#6F7580] ml-2 text-[11px] font-normal">
              {" "}
              ( {order.order_items.length} items ){" "}
            </span>
          </p>
          {order.fulfillment_status && order.fulfillment_status !== null && (
            <p
              className="ml-4 text-xs px-2 py-1 rounded"
              style={{
                color:
                  order.fulfillment_status === "Delivered"
                    ? "#16AC37"
                    : settings["--site-widget-primary-color"],
                background:
                  order.fulfillment_status === "Delivered"
                    ? "#E8F7EB"
                    : settings["--site-widget-primary-color-50"],
              }}
            >
              {order.fulfillment_status}
            </p>
          )}
          <RiArrowRightSLine
            className="ml-auto text-xl font-bold"
            color={`${settings["--site-widget-primary-color"]}`}
          />
        </div>
        <hr
          className="my-2"
          style={{
            borderTop: `1px dashed ${settings["--site-widget-primary-color"]}`,
          }}
        />

        {/* Line Items  */}
        <div>
          {order.order_items.slice(0, 2).map((orderItem) => {
            return (
              <div className="mt-4 flex items-center" key={orderItem.order_id}>
                <img
                  className="rounded-md w-12 h-12 mr-4 text-xs overflow-hidden"
                  src={orderItem.image_url}
                  alt={orderItem.product_title}
                />
                <div>
                  <p className="text-sm truncate w-60">
                    {orderItem.product_title}
                  </p>
                  <p style={{ color: "#858A93" }} className="mt-1 text-xs">
                    ₹ {orderItem.product_price} |{" "}
                    <span
                      style={{ maxWidth: "120px" }}
                      className="inline-flex truncate"
                    >
                      {orderItem.variant_name}
                    </span>{" "}
                    | Qty: {orderItem.quantity}
                  </p>
                </div>
              </div>
            );
          })}
          <div className="flex items-center">
            {order.order_items.length > 2 && (
              <div>
                <p className="mt-2 text-[10px] text-gray-500">
                  + {order.order_items.length - 2} more items
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      <hr
        className="my-2"
        style={{
          borderTop: `1px dashed ${settings["--site-widget-primary-color"]}`,
        }}
      />

      {order.total_discounts > 0 && (
        <div className="flex items-center justify-between text-xs mt-2">
          <p className="text-[#6F7580]">Coupon Discount</p>
          <p className="text-[#16AC37]">- ₹{order.total_discounts}</p>
        </div>
      )}
      <div className="flex items-center justify-between text-xs mt-2">
        <p className="text-[#6F7580]">Delivery Fee</p>
        <p className="text-[#424A59]">
          {order.total_shipping_price > 0
            ? `+ ₹ ${order.total_shipping_price}`
            : "Free"}
        </p>
      </div>
      <div className="flex items-center justify-between text-xs mt-2">
        <p className="text-[#6F7580]">
          Total Order Price {order.is_cod ? " (COD)" : " (Prepaid)"}
        </p>
        <p className="text-[#151F32]">₹ {order.total_order_price}</p>
      </div>
      <div className="flex items-center justify-between w-full mb-2 mt-4">
        {showReturnButton && (
          <div className="w-full">
            <button
              onClick={() => {
                // track("clicked_on_returns_button");
                setOpenRmsIframe(true);
                setReturnLoader(true);
                document.querySelector("body").classList.add("overflow-hidden");
              }}
              target="_blank"
              rel="noreferrer"
              className="text-xs justify-center w-full rounded flex p-2 items-center"
              style={{
                border: `1px solid ${settings["--site-widget-primary-color"]}`,
                color: settings["--site-widget-primary-color"],
              }}
            >
              Returns / Exchange
              {returnLoader ? (
                <ClipLoader
                  color={`${settings["--site-widget-primary-color"]}`}
                  cssOverride={{
                    height: "14px",
                    width: "14px",
                    marginLeft: "10px",
                  }}
                />
              ) : (
                <MdOutlineKeyboardArrowRight className="text-lg" />
              )}
            </button>
          </div>
        )}
        <div>
          {openRmsIframe && (
            <div>
              <div className="overlay" />
              <iframe
                className="fixed bottom-0 left-0"
                style={{
                  height: "90vh",
                  width: "100%",
                  maxWidth: "420px",
                  zIndex: 99999,
                  borderRadius: "10px",
                }}
                title="rmsIframe"
                src={order.return_exchange_url}
                onLoad={() => {
                  setReturnLoader(false);
                }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default OrderBox;
